module.exports = __webpack_public_path__ + "img/activity11.9595c77c.png";